var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuadCountyAfrican(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00398 10.7887H0.203207V20.1887H20.7435V10.7887H19.9428H1.00398ZM14.1868 4.24233C14.0282 2.3312 12.425 0.823242 10.4733 0.823242C8.52171 0.823242 6.91843 2.33118 6.7599 4.24233H0.203125V9.92582H20.7434V4.24233H14.1867H14.1868ZM7.56196 4.24233C7.71731 2.7728 8.96341 1.62401 10.4734 1.62401C11.9833 1.62401 13.2294 2.77278 13.3848 4.24233H7.56203H7.56196Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadCountyAfrican);
export default __webpack_public_path__ + "static/media/Quad County African.d584a6b02ab748664a73e0fefee31af7.svg";
export { ForwardRef as ReactComponent };